module.exports = __webpack_public_path__ + "static/st1-6-8576ab6e4835e08d7b068515fbdef40e.jpg";